var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dashboard-page",
      style: `${_vm.loading ? "height: 100%;" : "opacity:1;"}`,
    },
    [
      _vm.loading
        ? _c("loading-page")
        : _vm.dashboardParamsSet < 4
        ? _c(
            "div",
            { staticClass: "loading" },
            [
              _c(
                "v-container",
                { staticClass: "loading", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticStyle: { "margin-top": "15%" },
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _vm.dashboardParamsSet === 0
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "mb-2 text-center secondary-h1",
                                      class: {
                                        "light-text": !_vm.$vuetify.theme.dark,
                                      },
                                    },
                                    [
                                      _vm._v(" Dashboard parameters "),
                                      _c("br"),
                                      _vm._v("are not set "),
                                    ]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "mb-2 text-center secondary-h1",
                                      staticStyle: { "font-size": "22px" },
                                    },
                                    [
                                      _vm._v(" Not all dashboard "),
                                      _c("br"),
                                      _vm._v("parameters are set "),
                                    ]
                                  ),
                            ]
                          ),
                          !_vm.isAdmin
                            ? _c(
                                "p",
                                {
                                  staticClass: "text-center",
                                  staticStyle: {
                                    "letter-spacing": "0.02rem",
                                    "font-size": "15px",
                                  },
                                },
                                [_vm._v(" (Please refer to the Admin) ")]
                              )
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-5",
                                      staticStyle: {
                                        "font-family": "Dosis,sans-serif",
                                        "font-size": "16px",
                                        "font-weight": "400",
                                      },
                                      attrs: { color: "primary", large: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push("/settings")
                                        },
                                      },
                                    },
                                    [_vm._v(" Set parameters ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.error
        ? _c("default-page", {
            attrs: {
              buttonText: "Reload",
              button2Text: "Change url",
              errorMessage: _vm.error ? _vm.errorMessage : "",
              customErrorText: "There provided parameters led to an error",
            },
            on: {
              "button-clicked": _vm.reloadDashboard,
              "button2-clicked": function ($event) {
                return _vm.$router.push("/settings")
              },
            },
          })
        : _c(
            "v-container",
            { attrs: { id: "dashboard_container", fluid: "" } },
            [
              _c(
                "v-row",
                { staticClass: "row-class mx-0" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pa-0",
                      style: `height: 100%; background: ${
                        _vm.$vuetify.theme.dark ? "#2e353b" : "#fff"
                      };`,
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "primary reset-btn mt-1 mr-1",
                                          attrs: {
                                            rounded: "",
                                            icon: "",
                                            text: "",
                                            width: "28",
                                            height: "28",
                                          },
                                          on: { click: _vm.setFrameUrl },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: { "font-size": "16px" },
                                        },
                                        [_vm._v("fas fa-redo-alt")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Refresh")])]
                      ),
                      _c("iframe", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: {
                          id: "i_frame",
                          src: `${_vm.iframeUrl}`,
                          frameborder: "0",
                          allowtransparency: "",
                        },
                      }),
                      _c(
                        "v-overlay",
                        {
                          staticClass: "slow-overlay",
                          attrs: {
                            value: _vm.overlay,
                            color: "#2e353b",
                            absolute: "",
                            opacity: "1",
                          },
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 30,
                              color: "primary",
                              indeterminate: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }